(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baliaric-assistant"] && !Shopify.designMode) return;
  try {
    const opener = document.getElementById('baliaric-assistant-open');
  const dialog = document.getElementById('baliaric-assistant-dialog');
  const closer = document.getElementById('baliaric-assistant-close');
  const frame = document.getElementById('baliaric-assistant-frame');
  if (opener && dialog && closer && frame) {
    opener.addEventListener('click', () => {
      if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
      if (!dialog.open) dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      closer.focus();
    });
    closer.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
